import React, { useState, useEffect, useCallback, useRef } from 'react';
import { View, Image, Text, TextInput, TouchableOpacity } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useIsFocused } from '@react-navigation/native';
import Button from '../../components/Button';
import { LinearGradient } from "expo-linear-gradient";

import HeaderTabs from '../../components/HeaderTabs';

import styles from "./styles";
import balanceService from '../../services/balanceService';

const Certificates = ({ navigation, route }) => {

    const ref = useRef(null);
    const [value, setValue] = useState(0);
    const [valueToken, setValueToken] = useState(0);
    const [year, setYear] = useState(0);
    const [balance, setBalance] = useState(0);
    const isFocused = useIsFocused();

    useEffect(() => {
        //  getCategories();
    }, [isFocused]);

    useEffect(() => {
        let number = 0;
        number = Math.ceil(  // round to nearest integer
            Number(value / 1000)    // type cast your input
        );
        //if (number % 2 != 0 || number == 0)
        //    number++;

        setValueToken(number);
    }, [value]);

    useEffect(() => {
        //   console.log('route.params', route.params);
        if (route.params.id) {
            loadBalance();
        }
    }, [route.params]);

    const loadBalance = async () => {
        const authToken = await AsyncStorage.getItem('JWT_TOKEN');
        balanceService.getBalanceOfToken(authToken, route.params.id).then((response) => {
            setBalance(parseFloat(response?.data?.saldo + ''));
        }).catch((error) => {
        });
    }


    return (
        <>
            <HeaderTabs
                title={"Certificados"}
                iconLeft={"settings"}
                routeLeft={"MyAccount"}
                subtitle={"Certificado de Neutralização de Carbono"}
            />

            <View style={styles.container}>
                <View style={styles.view}>
                    <Text style={styles.label}>Total de CO2 Emitido (kg)</Text>
                    <TextInput
                        value={value}
                        placeholder="Total em kg"
                        style={styles.input}
                        autoCapitalize="none"
                        keyboardType='numeric'
                        onChangeText={(val) => setValue( val.replace(/[^0-9]/g, '') )}
                    ></TextInput>
                    {
                        value.length > 0 ?
                        <Text style={{fontSize: 14, color: 'blue'}}>Você está utilizando {valueToken} token(s) de carbono.</Text>
                        :
                        <Text style={{fontSize: 14, color: 'red'}}>Digite o total de CO2 Emitido em Kg.</Text>
                    }

                    <Text style={styles.label}>Total de Tokens (1 Token equivale a 1 crédito de carbono /1000 kg)</Text>
                    <TextInput
                        value={valueToken+''}
                        placeholder={"" + valueToken}
                        style={styles.input}
                        autoCapitalize="none"
                        editable={false}
                    ></TextInput>

                    <Text style={styles.label}>Digite o ano</Text>
                    <TextInput
                        value={year}
                        placeholder={"Ex. 2019, 2020, 2021..."}
                        style={styles.input}
                        autoCapitalize="none"
                        keyboardType='numeric'
                        maxLength={4}
                        onChangeText={(val) => setYear( val.replace(/[^0-9]/g, '') )}
                    ></TextInput>
                    {
                        year.length > 0 ? 
                        (
                            (parseInt(year) < 2010 || parseInt(year) > (new Date().getFullYear())) ?
                            <Text style={{fontSize: 14, color: 'blue'}}>Confirma o ano {year}?</Text>
                            :
                            <></>
                        )
                        :
                        (
                            <Text style={{fontSize: 14, color: 'red'}}>Digite o ano a ser neutralizado.</Text>
                        )
                    }
                </View>

            </View>
            {
                (
                    value && valueToken && year ?
                        (
                            balance >= valueToken ?
                                <View style={styles.contentBtn}>
                                    <TouchableOpacity onPress={() => navigation.navigate({
                                        name: 'CertificateEmit', params: {
                                            qtd: valueToken, idCoin: route.params.id, volume: value, year: year
                                        }
                                    })}><LinearGradient
                                        start={{ x: -1, y: 0 }}
                                        end={{ x: 1, y: 0 }}
                                        colors={["#16195B", "#1FBFB5"]}
                                        style={styles.btn}
                                    >
                                            <Text style={styles.textBtn}>Emitir certificado</Text>
                                        </LinearGradient>
                                    </TouchableOpacity>
                                </View>
                                :
                                <Button route={"DepositMethod"} text={"SALDO INSUFICIENTE"} />
                        )
                        :
                        (
                            <Button text={"PREENCHA OS CAMPOS"} disabled={true} />
                        )
                )
            }
        </>
    );
}

export default Certificates;